module.exports = __webpack_public_path__ + "img/notable_experiences.997f4b19.svg";